import { RectangleVertical, RectangleHorizontal } from 'lucide-react';
import type { Orientation } from '@/types/orientation.types';
import styles from './OrientationToggle.module.css';

export interface OrientationToggleProps {
  orientation: Orientation;
  onToggle: (orientation: Orientation) => void;
}

export function OrientationToggle({ orientation, onToggle }: OrientationToggleProps) {
  const isLandscape = orientation === 'landscape';

  const handleToggle = () => {
    onToggle(isLandscape ? 'portrait' : 'landscape');
  };

  return (
    <button
      type="button"
      className={styles.toggle}
      onClick={handleToggle}
      aria-label={`Switch to ${isLandscape ? 'portrait' : 'landscape'} orientation`}
      title={`${isLandscape ? 'Landscape' : 'Portrait'} orientation`}
    >
      {isLandscape ? (
        <RectangleHorizontal size={18} aria-hidden="true" />
      ) : (
        <RectangleVertical size={18} aria-hidden="true" />
      )}
    </button>
  );
}
